/**
 * Everyday Guide screen (Task 8) — secondary reference, not home.
 * Amount bands per docs/03 §10. Fictional issuers only in tests.
 */

import type { EverydayGuide } from '../../domain/recommend/everydayGuide';

export type EverydayGuideScreenProps = {
  guide: EverydayGuide | null;
};

export function EverydayGuideScreen({ guide }: EverydayGuideScreenProps): JSX.Element {
  return (
    <section data-testid="everyday-guide-screen" className="flex flex-col gap-4">
      <div>
        <h2 className="text-lg font-semibold text-slate-100">Everyday Guide</h2>
        <p className="mt-1 text-sm text-slate-400">
          {guide?.subtitle ??
            'Best card for a typical $100 purchase, assuming current capacity and eligibility.'}
        </p>
        {guide !== null ? (
          <p className="mt-1 text-xs text-slate-500">Computed {guide.computed_at}</p>
        ) : null}
      </div>

      {guide === null ? (
        <p className="rounded-lg border border-slate-800 bg-slate-900/40 p-4 text-sm text-slate-400">
          Guide not computed yet.
        </p>
      ) : (
        <div className="flex flex-col gap-3">
          {guide.rows.map((row) => (
            <article
              key={row.id}
              data-testid="everyday-guide-row"
              data-category={row.id}
              className="rounded-lg border border-slate-800 bg-slate-900/60 p-4"
            >
              <h3 className="mb-3 text-base font-medium capitalize text-slate-100">{row.label}</h3>
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
                {row.bands.map((band) => (
                  <div
                    key={band.band_id}
                    data-testid="everyday-guide-band"
                    data-band={band.band_id}
                    className="flex flex-col gap-1 rounded border border-slate-800/80 bg-slate-950/40 px-2 py-2"
                  >
                    <span className="text-xs uppercase tracking-wide text-slate-500">
                      {band.band_label}
                    </span>
                    <span className="text-sm text-slate-100">{band.winner_label}</span>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
